import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'wouter';
import { Box, Stack, Tabs, Tab } from '@mui/material';

import TabPanel from '../../../common/components/TabPanel';
import ListItemField from '../../../common/components/ListItemField';
import FormWrapper from '../../../common/components/FormWrapper';
import MeasureRow from './measureData/MeasureRow';
import childForms from './childForms';
import measureForm from './measureData/measureForm';
import clientSelector from '../../../clients/clientSelector';
import settingsSelectors from '../../../settings/settingsSelector';
import { loadClients } from '../../../clients/clientsReducer';
import { loadAdvisors } from '../../../settings/settingsReducer';
import { getClientPayloadType } from '../../../common/helpers/payloadType';
import type { AppDispatch } from '../../../store';
import type { Child } from '../../../common/types/child';

type Props = {
  child: Child;
  updateChild: (child: Child) => void;
  saveChild?: (child: Child) => void;
};

function ChildForm({ child, updateChild, saveChild }: Props) {
  const dispatch: AppDispatch = useDispatch();
  const [location] = useLocation();
  const [value, setValue] = React.useState(0);
  const clients = useSelector(clientSelector.getClients);
  const advisors = useSelector(settingsSelectors.getAdvisors);
  const payloadType = getClientPayloadType(location);

  const tabs = childForms(clients);

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  React.useEffect(() => {
    dispatch(loadClients(payloadType));
  }, [payloadType]);

  React.useEffect(() => {
    dispatch(loadAdvisors());
  }, []);

  return (
    <>
      <Box mx={3} sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs variant='scrollable' scrollButtons='auto' value={value} onChange={handleChange}>
          {tabs.map((tab) => (
            <Tab key={`${tab.title}_tab`} label={tab.title} />
          ))}
        </Tabs>
      </Box>
      <Stack px={3} pt={1} pb={2} overflow='auto scroll'>
        <Box component='form' noValidate autoComplete='off' maxWidth='650px'>
          {tabs.map((tab, index) => (
            <TabPanel key={`${tab.title}_panel`} value={value} index={index}>
              {tab.forms.map((form) => (
                <FormWrapper key={form.key} form={form} item={child} save={saveChild} update={updateChild} />
              ))}
              {tab.key === 'childDocuForm' && (
                <ListItemField
                  items={child.measures || []}
                  headline='Beratung'
                  buttonLabel='Notiz'
                  itemForm={measureForm(advisors)}
                  renderItemRow={(item) => <MeasureRow measure={item} />}
                  handleSave={(value) => {
                    if (saveChild !== null && saveChild !== undefined) {
                      saveChild({
                        ...child,
                        measures: value,
                      });
                    }
                  }}
                  handleChange={(value) => {
                    updateChild({
                      ...child,
                      measures: value,
                    });
                  }}
                />
              )}
            </TabPanel>
          ))}
        </Box>
      </Stack>
    </>
  );
}

export default ChildForm;
